






































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { State, Action, Getter } from 'vuex-class';
import { ClaimState, Claim, ClaimCommentPaginator } from '@/stores/claim/types';
import Paginator from '@/components/Paginator.vue';
import { PaginatorEvent, Comment, Attachment, PaymentType } from '@/types';
import { ClaimStatusColor } from '@/enums';
import NewCommentModal from '@/components/modals/NewCommentModal.vue';
import { claimService } from '@/services/claim.services';

const namespace: string = 'claim';

@Component({
    components: {
        Paginator,
        NewCommentModal,
    },
})
export default class ClaimView extends Vue {
    @State('claim') claimState!: ClaimState;
    @Action('get', { namespace }) getClaimData: any;
    @Action('postComment', { namespace }) postCommentData: any;
    @Action('getComments', { namespace }) getClaimComments: any;
    @Action('getAttachments', { namespace }) getClaimAttachments: any;
    @Action('getPayments', { namespace }) getClaimPayments: any;
    @Action('getReminders', { namespace }) getClaimRminders: any;
    @Action('getInterests', { namespace }) getClaimInterests: any;
    @Getter('comments', { namespace }) claimComments!: ClaimCommentPaginator;
    @Getter('attachments', { namespace }) claimAttachments!: Attachment[];
    @Getter('claim', { namespace }) claimData!: Claim;
    @Getter('reminders', { namespace }) claimReminders!: Comment[];
    @Getter('payments', { namespace }) claimPayments!: Comment[];
    @Getter('payments', { namespace }) claimCalculatorPayments!: Comment[];
    @Getter('interests', { namespace }) claimInterests!: string;

    fields: any = [
        {
            key: 'date',
            label: 'Date',
            sortable: true,
        },
        {
            key: 'attachments',
            label: 'Attachments',
            sortable: true,
            tdClass: 'handCursor',
        },
        {
            key: 'comment',
            label: 'Comment',
            sortable: true,
        },
        {
            key: 'amount',
            label: 'Amount',
            sortable: true,
        },
        {
            label: 'Created By',
            key: 'user.name',
            sortable: true,
        },
        {
            label: 'Assignee',
            key: 'assignee.name',
            sortable: true,
        },
        {
            key: 'reminder',
            label: 'Reminder',
            sortable: true,
        },
        {
            key: 'actions',
            label: 'Actions',
        },
    ];

    attachmentFields: any = [
        {
            key: 'inserted_at',
            label: 'Uploaded',
            sortable: true,
        },
        {
            label: 'Comment',
            key: 'comment.comment',
            sortable: true,
        },
        {
            key: 'filename',
            label: 'Filename',
            sortable: true,
            tdClass: 'handCursor',
        },
        {
            key: 'actions',
            label: 'Actions',
        },
    ];

    reminderFields: any = [
        {
            key: 'reminder',
            label: 'Reminder',
            sortable: true,
        },
        {
            key: 'comment',
            label: 'Comment',
            sortable: true,
        },
        {
            label: 'Assignee',
            key: 'assignee.name',
            sortable: true,
        },
        {
            key: 'actions',
            label: 'Actions',
        },
    ];

    manualCalculator: any = [
        {
            key: 'amount',
            label: 'Amount',
        },
        {
            key: 'date',
            label: 'Payment Date',
        },
        {
            key: 'interest',
            label: 'Interests',
        },
        {
            key: 'comment',
            label: 'Comment',
        },
        {
            key: 'type',
            label: 'Payment Type',
        },
    ];

    currentCommentPage: any = 1;
    commentsPerPage: any = 10;
    paymentTypes: PaymentType[] = [];

    editComment: Comment = {
        comment: '',
    };

    tempPayment: Comment = {
        comment: '',
        amount: undefined,
        assignee_id: '',
        payment_type_id: undefined,
        date: '',
        interest: false,
    };

    updateComments() {
        this.getClaimComments({
            id: this.$route.params.id,
            page: this.currentCommentPage,
            perPage: this.commentsPerPage,
        });
    }

    updatePaginate(paginatorObject: PaginatorEvent) {
        this.commentsPerPage = paginatorObject.perPage;
        this.currentCommentPage = paginatorObject.currentPage;
        this.updateComments();
    }

    mounted() {
        this.getClaimData({id: this.$route.params.id});
        claimService.getPaymentTypes()
        .then((result) => {
            this.paymentTypes = result.data.data;
        });
    }

    get comments() {
        return this.claimComments && this.claimComments.data;
    }

    get commentsPages() {
        return this.claimComments && this.claimComments.metadata;
    }

    get claim() {
        return this.claimData;
    }

    get attachments() {
        return this.claimAttachments;
    }

    get payments() {
        return this.claimPayments;
    }

    get calculatorPayments() {
        return this.claimCalculatorPayments;
    }

    get reminders() {
        return this.claimReminders;
    }

    get interests() {
        return this.claimInterests;
    }

    statusColor(status: 'NEW'|'IN_PROGRESS'|'DONE'|'CANCELED'|'ARCHIVED') {
        return status && ClaimStatusColor[status];
    }

    openNewClaimCommentModal() {
        this.editComment = {
            comment: '',
        };
        this.$nextTick(() => {
            ((this.$refs.newCommentModalRef) as any).showModal();
        });
    }

    openEditClaimCommentModal(comment: Comment) {
        this.editComment = comment;
        this.$nextTick(() => {
            ((this.$refs.newCommentModalRef) as any).showModal();
        });
    }

    openEditClaimPaymensModal(payment: Comment) {
        this.editComment = payment;
        this.$nextTick(() => {
            ((this.$refs.newCommentModalRef) as any).showModal();
        });
    }

    openEditClaimRemindersModal(reminder: Comment) {
        this.editComment = reminder;
        this.$nextTick(() => {
            ((this.$refs.newCommentModalRef) as any).showModal();
        });
    }

    saveNewComment(comment: Comment) {
        this.postCommentData({
            id: this.claim.id,
            comment,
            page: this.currentCommentPage,
            perPage: this.commentsPerPage,
        });
    }

    saveTempPayment() {
        this.postCommentData({
            id: this.claim.id,
            comment: this.tempPayment,
            page: this.currentCommentPage,
            perPage: this.commentsPerPage,
        })
        .then(() => {
            this.tempPayment = {
                comment: '',
                amount: undefined,
                assignee_id: '',
                payment_type_id: undefined,
                date: '',
                interest: false,
            };
        });
    }

    downloadAttachment(id: string, filename: string) {
        claimService.downloadAttachment(id, filename);
    }

    downloadReport() {
        claimService.downloadReport(this.$route.params.id)
        .catch((err) => {
            alert('Error creating PDF. Try to calculate first.');
        });
    }

    calculateInterest() {
        this.getClaimInterests({
            id: this.$route.params.id,
        });
    }

    checkTempPayment() {
        if (this.tempPayment.amount && this.tempPayment.date) {
            return false;
        }
        return true;
    }
}
